export const distanceSkiSchool: {
    label: string;
    criterias: string[];
    isAvailable: {
        criterias: string[];
    };
}[] = [
    {
        label: 'A côté',
        criterias: ['365'],
        isAvailable: {
            criterias: ['365']
        }
    },
    {
        label: '200 mètres max',
        criterias: ['365', '359'],
        isAvailable: {
            criterias: ['359']
        }
    },
    {
        label: '500 mètres max',
        criterias: ['365', '359', '360'],
        isAvailable: {
            criterias: ['360']
        }
    },
    {
        label: '1 Km max',
        criterias: ['365', '359', '360', '361'],
        isAvailable: {
            criterias: ['361']
        }
    },
    {
        label: '5 Km max',
        criterias: ['365', '359', '360', '361', '362'],
        isAvailable: {
            criterias: ['362']
        }
    },
    {
        label: '20 Km max',
        criterias: ['365', '359', '360', '361', '362', '363'],
        isAvailable: {
            criterias: ['363']
        }
    },
    {
        label: 'A + de 20 Km',
        criterias: ['365', '359', '360', '361', '362', '363', '364'],
        isAvailable: {
            criterias: ['364']
        }
    }
]